module.exports = __webpack_public_path__ + "img/h.04075ea6.png";